enum DropzoneStatesEnum {
  DEFAULT = 'default',
  ACTIVE = 'active',
  ACCEPTED = 'accepted',
  ERROR = 'error',
}

export default DropzoneStatesEnum;
